export default (tags = []) => {
  let icon = {
    name: '',
    color: '',
    bg: ''
  };

  if (tags.includes('alert')) {
    icon.name = 'mdi-bell-ring';
    if (tags.includes('triggered')) {
      icon.color = 'red';
    }
    return icon;
  } else if (tags.includes('notice')) {
    icon.name = 'mdi-volume-high';
    return icon;
  }

  icon.name = 'mdi-message-text';

  return icon;
};
